import { __awaiter, __extends, __generator } from "tslib";
import { QueryCommand as __QueryCommand, } from "@aws-sdk/client-dynamodb";
import { DynamoDBDocumentClientCommand } from "../baseCommand/DynamoDBDocumentClientCommand";
var QueryCommand = (function (_super) {
    __extends(QueryCommand, _super);
    function QueryCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        _this.inputKeyNodes = [
            {
                key: "KeyConditions",
                children: {
                    children: [{ key: "AttributeValueList" }],
                },
            },
            {
                key: "QueryFilter",
                children: {
                    children: [{ key: "AttributeValueList" }],
                },
            },
            { key: "ExclusiveStartKey" },
            { key: "ExpressionAttributeValues" },
        ];
        _this.outputKeyNodes = [{ key: "Items" }, { key: "LastEvaluatedKey" }];
        _this.clientCommand = new __QueryCommand(_this.input);
        _this.middlewareStack = _this.clientCommand.middlewareStack;
        return _this;
    }
    QueryCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        var _this = this;
        this.addMarshallingMiddleware(configuration);
        var stack = clientStack.concat(this.middlewareStack);
        var handler = this.clientCommand.resolveMiddleware(stack, configuration, options);
        return function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2, handler(this.clientCommand)];
        }); }); };
    };
    return QueryCommand;
}(DynamoDBDocumentClientCommand));
export { QueryCommand };
